import { useState, useMemo, useCallback } from 'react';
import { BrandliveEvent, EPermissions } from '../../../types/working-model';
import { Link } from 'react-router-dom';
import Icon, { ICONS, COLORS } from '../../general-ui/icon';
import { useDispatch, useSelector } from 'react-redux';
import { clearPublishedUrl, clearWorkingEvent, setSelectedEvent } from '../../../store/actions/admin/create-event';
import EventSettings from './event-settings-modal';
import { getStartTime } from '../../../utils/get-event-start-time';
import { Status } from '../../../types/event';

import { PATHNAMES } from '../admin';
import { userHasRoleOnActiveChannel } from '../../../utils/utils';
import { EventsState } from '../../../store/types';

interface Props {
	event?: BrandliveEvent;
	eventRegistrations?: number;
	isLive?: boolean;
}

export function getEventLink(event: BrandliveEvent): string {
	// if a single session event doesnt have a landing page, redirect to event path
	if (!event.homepage) {
		return PATHNAMES.Event.EventLink(event.uuid);
	} else {
		return PATHNAMES.Event.LandingLink(event.uuid);
	}
}

export default function EventCard(props: Props): JSX.Element {

	const dispatch = useDispatch();

	const {
		user
	} = useSelector((state: EventsState) => state.AuthReducer);

	const { event, eventRegistrations, isLive } = props;

	const [settingsOpen, setSettingsOpen] = useState(false);

	const startTime = useMemo(() => {
		return getStartTime(event!, true);
	}, [event]);

	function getStatus() {
		if (isLive) {
			return (
				<div className="card-status live">
					{"Live"}
				</div>
			);
		}
		switch (event?.status) {
			case Status.Deleted:
			case Status.Published: {
				return (
					<div className="card-status">
						{Status[event.status]}
					</div>
				);
			}
			case Status.Unpublished: {
				return (
					<div className="card-status unpublished">
						{Status[event.status]}
					</div>
				);
			}
			default: {
				return (
					<div className="card-status error">
						{"None"}
					</div>
				);
			}
		}
	}

	const handleLink = useCallback(() => {
		dispatch(clearPublishedUrl());
		dispatch(clearWorkingEvent());
	}, [dispatch]);

	const selectEvent = () => {
		dispatch(setSelectedEvent(event!));
	};

	return (
		<>
			{event && setSelectedEvent ? (
				<div className="event-card">
					<div className="card-header">
						<div>
							{startTime}
						</div>
						{/* FUTURE DEV - removing ellipsis on event cards until fully functional */}
						{/* <div>
							<button className="passcode-edit no-style" onClick={() => setSettingsOpen(true)}><Icon name={ICONS.THREE_DOTS_VERTICAL} size={16} color={COLORS.WHITE} /></button>
						</div> */}
					</div>
					<div className="card-title">
						{userHasRoleOnActiveChannel([EPermissions.Owner, EPermissions.Admin], user!) ?
							<Link onClick={handleLink} to={getEventLink(event!)}><h5>{event.name}</h5></Link>
							: <h5 onClick={selectEvent}>{event.name}</h5>
						}
					</div>
					<div className="card-info">
						{getStatus()}
						<div className="card-registrations">
							{eventRegistrations ?? 0} registrations
						</div>
					</div>
					<div className="card-footer">
						<div>{/* <AccessIcons addAccess={false}/> */}</div>
						<button className="footer-link no-style" onClick={selectEvent}>
							<h6>Details</h6>
							<Icon name={ICONS.ARROW_RIGHT} size={12} color={COLORS.WHITE} />
						</button>
					</div>
					<EventSettings
						event={event}
						open={settingsOpen}
						setOpen={setSettingsOpen}
					/>
				</div>
			) : (<></>)}
		</>
	);
}